import React from 'react';

function removeSpacesFromText(text) {
  return text.replace(/ /g, '-');
}

export default removeSpacesFromText;
